import moment from 'moment-timezone';
import 'moment/locale/fi';

moment.locale('fi');
moment.tz.setDefault('Europe/Helsinki');

const getMomentTime = (time, format) => {
  if (time === undefined || time === null) {
    return moment();
  } else if (moment.isMoment(time)) {
    //if already a moment object is passed, return it.
    return time;
  } else if (
    typeof time === 'number' ||
    time.includes('+') ||
    time.includes('Z')
  ) {
    if (format) {
      return moment(time, format);
    } else {
      return moment(time);
    }
  }
  if (format) {
    return moment.tz(time, format, 'Europe/Helsinki');
  } else {
    return moment.tz(time, 'Europe/Helsinki');
  }

  //return moment.tz(time, "Europe/Helsinki")/*.tz("Europe/Helsinki");*/
};
export const getTime = (time, format) => {
  return getMomentTime(time, format);
};

export const formatISO8601 = (time) => {
  return formatCustom(time, 'YYYY-MM-DDThh:mm:ss');
};
export const formatTime = (time) => {
  return formatCustom(time, 'H.mm');
};
export const formatDate = (time) => {
  return formatCustom(time, 'D.M.YYYY'); // e.g. 06.07.2020
};
export const formatShortDate = (time) => {
  return formatCustom(time, 'l'); // e.g. 6.7.2020
};
// Return formatted date, or "Tänään" if time equals comparison time
// or "Eilen" if time equals comparison time - 1 day.
// This implementation is missing localization
export const formatCalendar = (time, comparisonTime = getTime()) => {
  return time.calendar(comparisonTime);
};
// Return formatted date, or "Tänään" if time equals comparison time
// or "Eilen" if time equals comparison time - 1 day.
// This implementation is missing localization
export const formatCalendarDay = (time, comparisonTime = getTime()) => {
  return time.calendar(comparisonTime, {
    sameDay: '[Tänään]',
    nextDay: '[Huomenna]',
    nextWeek: 'dddd',
    lastDay: '[Eilen]',
    lastWeek: '[Viime] dddd',
    sameElse: 'DD.MM.YYYY',
  });
};

export const formatYear = (time) => {
  return formatCustom(time, 'YYYY');
};
export const formatMonthAndDay = (time) => {
  return formatCustom(time, 'DD.MM.');
};
export const formatWeekDay = (time) => {
  return formatCustom(time, 'ddd');
};
export const formatCustom = (time, format) => {
  if (!time) return '';
  return getTime(time).format(format);
};

export const timeDifference = (start, end, amount, units = 'minutes') => {
  return moment.duration(start.diff(end)).as(units) > amount;
};
